import { memo } from 'react';
import { Box } from '@bonanza-social/moonlight';
import {
  StatusInstructions,
  StatusResetDisclaimer,
  StatusTitleText,
} from '../../components';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectStatus } from '../../state';

function LegacyStatusInfo() {
  const status = useSelector(selectStatus);

  if (!status) {
    return null;
  }

  return (
    <Box alignItems="center" gap="space-400">
      <StatusTitleText locKey="status_info_title" />
      <StatusInstructions status={status} />
      <StatusResetDisclaimer status={status} />
    </Box>
  );
}

export default memo(LegacyStatusInfo);
